import produce from 'immer';
import {
  MANAGER_LOGIN_LOG_LIST_REQUEST,
  MANAGER_TWOFACTOR_LOG_LIST_REQUEST,
  MANAGER_WORKED_LOG_LIST_REQUEST,
  SET_MANAGER_LOGIN_LOG_LIST,
  SET_MANAGER_TWOFACTOR_LOG_LIST,
  SET_MANAGER_WORKED_LOG_LIST,
  SET_LOG_PAGENATION, SET_LOG_SEARCH_VAL
} from '../../constants/backoffice/logConstants';

const initialState = {
  loginLogList: [],
  twofactorLogList: [],
  workedLogList: [],
  page: 1,
  pageLength: 10,
  totalCount: 0,
  beginDate: undefined,
  endDate: undefined,
  searchCode: undefined,
  searchString: undefined,
  noteSearch: undefined,
};

/* eslint-disable default-case, no-param-reassign */
const managerReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case MANAGER_WORKED_LOG_LIST_REQUEST:
    case MANAGER_TWOFACTOR_LOG_LIST_REQUEST:
    case MANAGER_LOGIN_LOG_LIST_REQUEST:
      break;

    case SET_LOG_SEARCH_VAL:
      draft.beginDate = action.beginDate;
      draft.endDate = action.endDate;
      draft.searchCode = action.searchCode;
      draft.searchString = action.searchString;
      draft.noteSearch = action.noteSearch;
      break;

    case SET_LOG_PAGENATION:
      draft.page = action.page;
      draft.pageLength = action.pageLength;
      draft.totalCount = action.totalCount;
      break;

    case SET_MANAGER_LOGIN_LOG_LIST:
      draft.loginLogList = action.list;
      break;

    case SET_MANAGER_TWOFACTOR_LOG_LIST:
      draft.twofactorLogList = action.list;
      break;

    case SET_MANAGER_WORKED_LOG_LIST:
      draft.workedLogList = action.list;
      break;
  }
});

export default managerReducer;
